import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            textStyle: ['body-medium'],
        },
        grid: {
            position: 'relative',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: remCalc(16),
            maxWidth: `min(100%, ${remCalc(1448)})`,
            mx: 'auto',
            py: {base: remCalc(8), sm: remCalc(20), md: remCalc(24), lg: remCalc(40)},
        },
        icon: {
            minW: remCalc(60),
        },
        content: {
            direction: 'column',
            gap: remCalc(16),
        },
        heading: {
            fontWeight: 'medium',
        },
        bodycopy: {},
        links: {
            alignItems: 'flex-start',
            gap: remCalc(16),
        },
        anchor: {
            textStyle: 'body-small',
            color: 'text.tertiary',
            fontWeight: 'bold',
            _hover: {
                textDecoration: 'none',
            },
        },
    },
}
